import { IAxiosGetResponse } from '../interfaces/IUtilities';
import axiosInstance from '../../setup/axios/axiosInstance';

export const getAll = async (apiUrl: string, params: string) => {
    try {
        const response = await axiosInstance.get(apiUrl + params);
        return { response: response.request, data: response.data } as IAxiosGetResponse;
    } catch (error: any) {
        return error.response;
    }
};

export const getById = async (apiUrl: string, id: string) => {
    let params = id;
    try {
        const response = await axiosInstance.get(apiUrl + params);
        return {response : response.request,data: response.data} as IAxiosGetResponse;
    } catch (error: any) {
        return error.response;
    }
};

export const deleteById = async (apiUrl: string, id: string) => {
    let params = '/?id=' + id;
    try {
        const response = await axiosInstance.delete(apiUrl + params);
        return response.request;
    } catch (error: any) {
        return error.response;
    }
};

export const deleteLibraryTransactionRoute = async (libraryId: number, transactionRouteId: string) => {
    try {
        const response = await axiosInstance.delete(
            `/api/library/${libraryId}/transactionroutes/${transactionRouteId}`
        );
        return response;
    } catch (error: any) {
        console.error(error);
        return error.response;
    }
};

export const create = async (apiUrl: string, object: any) => {
    return await axiosInstance
    .post(apiUrl, object)
    .then((response) => response.request)
    .catch((error) => {
        return error.response;
    })
};

export const update = async (apiUrl: string, object: any) => {
    return await axiosInstance
    .put(apiUrl, object)
    .then((response) => response.request)
    .catch((error) => {
        return error.response;
    })
};

export const updateDetails = async (apiUrl: string, object: any, throwOnError: boolean = false) => {
    try {
        const response = await axiosInstance.put(apiUrl, object);
        return { response: response.request, data: response.data };
    } catch (error: any) {
        if (throwOnError) throw error;
        return {
            response: error.response?.request || null,
            data: error.response?.data || { message: error.message || 'Unknown error' }
        };
    }
};

export const updateById = async (apiUrl: string, id: string) => {
    let params = '/?id=' + id;
    try {
        const response = await axiosInstance.put(apiUrl + params);
        return {response : response.request,data: response.data} as IAxiosGetResponse;
    } catch (error: any) {
        return error.response;
    }
};

export const post = async (
    apiUrl: string,
    data: any,
    isFormData: boolean = false,
    throwOnError: boolean = false
): Promise<IAxiosGetResponse | any> => {
    try {
        const headers = {
            'Content-Type': isFormData ? 'multipart/form-data' : 'application/json'
        };
        const response = await axiosInstance.post(apiUrl, data, { headers});

        return { response: response.request, data: response.data } as IAxiosGetResponse;
    } catch (error: any) {
        if(throwOnError) throw error;
        return {
            response: error.response?.request || null,
            data: error.response?.data || { message: error.message || 'Unknown error' }
        } as IAxiosGetResponse;
    }
};

export const getLibraryContents = async (libraryPath: string) => {
    try {
        const response = await axiosInstance.get(`/api/library/contents?libraryPath=${encodeURIComponent(libraryPath)}`);
        return { response: response.request, data: response.data } as IAxiosGetResponse;
    } catch (error: any) {
        return error.response;
    }
};

export const getLibrarySyncOverview = async (libraryPath: string, includeBcc: boolean = true) => {
    try {
        const response = await axiosInstance.get(`/api/library/syncoverview?libraryPath=${encodeURIComponent(libraryPath)}&includeBcc=${includeBcc}`);
        return { response, data: response.data } as IAxiosGetResponse;
    } catch (error: any) {
        return error.response;
    }
};

export const syncLibraryAcrossSites = async (libraryPath: string, syncPrimary: boolean, syncBcc: boolean) => {
    try {
        const response = await axiosInstance.post(`/api/library/syncsites`, { libraryPath, syncPrimary, syncBcc });
        return { response, data: response.data } as IAxiosGetResponse;
    } catch (error: any) {
        return error.response;
    }
};

export const syncLibraryFromFileSystem = async (libraryPath: string, syncBcc: boolean) => {
    try {
        const response = await axiosInstance.post(`/api/library/syncfromfilesystem`, { libraryPath, syncPrimary: true, syncBcc });
        return { response, data: response.data } as IAxiosGetResponse;
    } catch (error: any) {
        return error.response;
    }
};

export const syncLibraryDatabases = async (libraryPath: string) => {
    try {
        const response = await axiosInstance.post(`/api/library/syncdatabases`, { libraryPath });
        return { response, data: response.data } as IAxiosGetResponse;
    } catch (error: any) {
        return error.response;
    }
};

export const remove = async (
    apiUrl: string,
    options?: { params?: Record<string, any>; data?: any }
) => {
    try {
        const response = await axiosInstance.delete(apiUrl, {
        params: options?.params,
        data: options?.data,
        });
        return { response: response.request, data: response.data };
    } catch (error: any) {
        return error.response;
    }
};



